import { useMutation } from "@apollo/client/react";import React, { useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import SAVE_VISITA_TELE_ENFERMERIA_AP, { adaptAddVisitaTeleEnfermeriaAPInput } from "../../../../../../data/graphQL/mutations/Visitas/saveTeleEnfermeriaAP";
import { useVisita } from "../../../../../../context/VisitaContext";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function Cateter({ esUrgencia, readOnly, onSaveRef, onExposeFormatted }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  //QUERY y MUTATION
  const [save] = useMutation(SAVE_VISITA_TELE_ENFERMERIA_AP);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      switch (input.name) {
        case "fechaUltimaCuracion":
          newInput.minDate = null;
          newInput.maxDate = new Date();
          break;
        default:
          break;
      }

      if (esUrgencia) newInput.required = false;

      if (readOnly) newInput.disabled = true;

      return newInput;
    });

  }, [readOnly, esUrgencia]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { input: adaptAddVisitaTeleEnfermeriaAPInput(formData) } });

    const idTeleEnfermeriaAPNueva = data?.saveVisitaTeleEnfermeriaAP?.idTeleEnfermeriaAP;
    if (!idTeleEnfermeriaAPNueva) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData,
      idTeleEnfermeriaAP: idTeleEnfermeriaAPNueva
    }));

  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'cateter',
      stepName: 'Cateter',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox>
            <Grid container spacing={2}>
                {formattedInputs.map((input) =>
        <Grid size={{ xs: 12 }} key={input.name}>
                        <RenderInputByTypeMobile
            key={input.name}
            input={input}
            value={formData[input.name]}
            handleChange={handleChange} />
          
                    </Grid>
        )}
            </Grid>
        </CardBox>);

}

const inputs = [
{
  name: "permeable",
  displayName: "¿Está permeable?",
  type: "boolean",
  required: true,
  lightTitle: true
},
{
  name: "fijacion",
  displayName: "¿Cómo se encuentra la fijación?",
  type: "long_string",
  required: true,
  maxLength: 250
},
{
  name: "desplazo",
  displayName: "¿En algún momento se desplazó?",
  type: "boolean",
  required: true,
  lightTitle: true
},
{
  name: "accionDesplazo",
  displayName: "¿Qué hizo si esto pasó?",
  type: "long_string",
  required: true,
  maxLength: 250
},
{
  name: "frecuenciaCuracion",
  displayName: "¿Con qué frecuencia realiza la curación?",
  type: "long_string",
  required: true,
  maxLength: 250
},
{
  name: "formaCuracion",
  displayName: "¿De qué forma?",
  type: "long_string",
  required: true,
  maxLength: 250
},
{
  name: "fechaUltimaCuracion",
  displayName: "¿Cuándo lo curó por última vez?",
  type: "date",
  required: true
},
{
  name: "quienCuro",
  displayName: "¿Quién lo hizo?",
  type: "long_string",
  required: true,
  maxLength: 250
},
{
  name: "sitioSalida",
  displayName: "¿Cómo se encuentra el sitio de salida?",
  type: "long_string",
  required: true,
  maxLength: 250
},
{
  name: "alteracionLlamativa",
  displayName: "¿Nota alguna alteración que le llame la atención?",
  longLabel: true,
  type: "long_string",
  required: true,
  maxLength: 250
},
{
  name: "observaTitle",
  displayName: "Observa",
  type: "text",
  sxText: {
    fontWeight: 'bold',
    fontSize: '15px'
  }
},
{
  name: "dolor",
  displayName: "Dolor",
  type: "boolean",
  required: true,
  lightTitle: true
},
{
  name: "supuracion",
  displayName: "Supuración",
  type: "boolean",
  required: true,
  lightTitle: true
},
{
  name: "eritemas",
  displayName: "Eritemas",
  type: "boolean",
  required: true,
  lightTitle: true
},
{
  name: "granulomasSangrado",
  displayName: "Granulomas o sangrado",
  type: "boolean",
  required: true,
  lightTitle: true
},
{
  name: "bionector",
  displayName: "¿El catéter tiene colocado un bionector de forma permanente?",
  type: "boolean",
  required: true,
  lightTitle: true
},
{
  name: "cadaCuantoCambia",
  displayName: "¿Cada cuánto lo cambia?",
  type: "long_string",
  required: true,
  maxLength: 250
},
{
  name: "desinfeccion",
  displayName: "¿Cómo realiza su desinfección?",
  type: "long_string",
  required: true,
  maxLength: 250
},
{
  name: "parche",
  displayName: "¿Qué parche utiliza?",
  type: "long_string",
  required: true,
  maxLength: 250
}];